/**
 * @author Iulian Ceapa <dev@sitemd.net>
 * @copyright © 2019-2026 SiteMD.
 */

const swiper_section_2 = new Swiper('#section-2 .swiper', {
    breakpoints: {
        0: {
            slidesPerView: 'auto',
            spaceBetween: 16
        },
        768: {
            slidesPerView: 'auto',
            spaceBetween: 24
        },
        992: {
            spaceBetween: 96
        },
        1400: {
            spaceBetween: 110
        }
    },
    grabCursor: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    slidesPerView: 1,
    spaceBetween: 110,
    loop: false
});

const swiper_section_3 = new Swiper('#section-3 .swiper', {
    // autoHeight: true,
    breakpoints: {
        0: {
            slidesPerView: 'auto',
            spaceBetween: 16
        },
        768: {
            slidesPerView: 'auto',
            spaceBetween: 24
        },
        1200: {
            slidesPerView: 3,
        }
    },
    grabCursor: true,
    slidesPerView: 3,
    spaceBetween: 24,
    loop: false
});

document.querySelectorAll('.section-2 .service-details__info').forEach(wrapper => {
    const inner = wrapper.querySelector('.section-2 .service-details__info > div');
    if (!inner) return;

    const toggleGradient = () => {
        const isBottom =
            inner.scrollTop + inner.clientHeight >= inner.scrollHeight - 1;

        wrapper.classList.toggle('has-gradient', !isBottom);
    };

    toggleGradient(); // stare inițială
    inner.addEventListener('scroll', toggleGradient);
});